import { api as apiService, ApiService } from "./api"

class WorkService {
  constructor(private readonly api: ApiService) {}

  public getWorkInProgress = async () => {
    return await this.api.get(toranjaURL + `/work/?workInProgress=true`)
  }
}
const toranjaURL = process.env.REACT_APP_TORANJA_API
export const workService = new WorkService(apiService)
